import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { KITCHEN_PRICE_PDP_LANDING_NAME } from 'landings';
import { FETCH_COLLECTION_INFO, FETCH_COLLECTIONS, ResponseCollectionList } from 'modules/collections';
import { FETCH_RELATED_SERVICES } from 'modules/related-services';
import { State } from 'store/types';
import { KitchenPricePdpRemote } from '../../common/widgets';
import { initWidgetData } from '../init-widget-data';

registerWidget<State, Record<string, string>>(`${__NAME__}/${KITCHEN_PRICE_PDP_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = initWidgetData(state);
  if ('collectionList' in state.collections) {
      const collectionState = {
        collectionList: state.collections.collectionList,
        offset: state.collections.offset,
        productsCount: state.collections.productsCount,
        facets: state.collections.facets,
      } as ResponseCollectionList;
  
      store.dispatch(FETCH_COLLECTIONS.success, collectionState);
    }
  store.dispatch(FETCH_COLLECTION_INFO.success, state.collections.collectionInfo ?? undefined);
  store.dispatch(FETCH_RELATED_SERVICES.success, state.relatedServices.serviceList ?? undefined);

  return remoteProps => <KitchenPricePdpRemote router={router} store={store} {...remoteProps} />;
});
